import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import SourceFlowText from "@sourceflow-uk/sourceflowtext"
import {
    Container,
    Row,
    Col,
    Card,
    Nav,
    NavItem
} from 'reactstrap';
import Link from "next/link"
import LinkedIn from '/public/site-assets/svg/linkedin.svg';
import Mail from '/public/site-assets/svg/mail.svg';
import Phone from '/public/site-assets/svg/telephone.svg';
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import styles from './styles.module.scss';

export default function AllConsultants({
    global,
    pathPrefix,
    customClass = "",
    content,
    content_2,
    post,
    post2
}) {
    Fancybox.bind("[data-src]", {
        // Your custom options
    });
    return (
        post.length >= 1 && (
            <section className={`${styles.root} ${customClass}`}>
                <Container>
                    {content ?
                        <div className="mb-4">
                            <SourceFlowText global={global} path={`${pathPrefix}.content`} type="html">
                                {content}
                            </SourceFlowText>
                        </div> : null}
                    <Row>
                        {post?.map((post, index) => (
                            <Col md={4} lg={3} key={index} className="mb-4">
                                <Card className="bg-transparent border-0 h-100">
                                    <button className="rounded-5 overflow-hidden h-100 d-block border-0 p-0"
                                    >
                                        <SourceFlowImage
                                            src={post?.image ? post.image : "/site-assets/placeholders/img-placeholder.jpg"}
                                            size="1000x"
                                            alt={post?.title}
                                            className="card-img rounded-0"
                                        />
                                    </button>
                                    <div className="p-3">
                                        <p className="post-title fs-5 mb-0"><strong>{post?.title}</strong></p>
                                        <p className="post-position">{post?.position}</p>
                                        <Nav className="d-flex contacts mt-2">
                                            {post.email ?
                                                <NavItem className="position-relative">
                                                    <Link href={`mailto:${post?.email}`}>
                                                        <a className="text-decoration-none" title="Mail">
                                                            <Mail />
                                                        </a>
                                                    </Link>
                                                </NavItem> : null}
                                            {post.telephone ?
                                                <NavItem className="position-relative">
                                                    <Link href={`tel:${post?.telephone}`}>
                                                        <a className="text-decoration-none" title="Telephone">
                                                            <Phone />
                                                        </a>
                                                    </Link>
                                                </NavItem> : null}
                                            {post.linkedin ?
                                                <NavItem className="position-relative">
                                                    <Link href={`${post?.linkedin}`}>
                                                        <a className="text-decoration-none" target="_blank" rel="noopener noreferrer" title="LinkedIn">
                                                            <LinkedIn />
                                                        </a>
                                                    </Link>
                                                </NavItem> : null}
                                        </Nav>
                                    </div>
                                    {post?.content ?
                                        <div id={`${post.url_slug}-content`} className="consultant-pop-content p-0 rounded-4">
                                            <Row className="">
                                                <Col md={4}>
                                                    <SourceFlowImage
                                                        src={post?.image ? post.image : "/site-assets/placeholders/img-placeholder.jpg"}
                                                        size="x1000"
                                                        alt={post?.title}
                                                        className="card-img rounded-4 h-100"
                                                    />
                                                </Col>
                                                <Col md={8} className="p-4 p-md-5">
                                                    <p className="post-title fs-5 mb-0"><strong>{post?.title}</strong></p>
                                                    <p className="post-position">{post?.position}</p>
                                                    <Nav className="d-flex contacts mt-2">
                                                        {post.email ?
                                                            <NavItem className="position-relative">
                                                                <Link href={`mailto:${post?.email}`}>
                                                                    <a className="text-decoration-none" title="Mail">
                                                                        <Mail />
                                                                    </a>
                                                                </Link>
                                                            </NavItem> : null}
                                                        {post.telephone ?
                                                            <NavItem className="position-relative">
                                                                <Link href={`tel:${post?.telephone}`}>
                                                                    <a className="text-decoration-none" title="Telephone">
                                                                        <Phone />
                                                                    </a>
                                                                </Link>
                                                            </NavItem> : null}
                                                        {post.linkedin ?
                                                            <NavItem className="position-relative">
                                                                <Link href={`${post?.linkedin}`}>
                                                                    <a className="text-decoration-none" target="_blank" rel="noopener noreferrer" title="LinkedIn">
                                                                        <LinkedIn />
                                                                    </a>
                                                                </Link>
                                                            </NavItem> : null}
                                                    </Nav>
                                                    {post?.content ?
                                                        <div className="post-content mt-5" dangerouslySetInnerHTML={{ __html: post?.content }} />
                                                        : ""}
                                                </Col>
                                            </Row>
                                        </div> : null}
                                </Card>
                            </Col>
                        ))}
                    </Row>
                    {post2.length >= 1 && (
                        <>
                            <hr></hr>
                            {content_2 ?
                                <div className="mb-4 mt-5">
                                    <SourceFlowText global={global} path={`${pathPrefix}.content_2`} type="html">
                                        {content_2}
                                    </SourceFlowText>
                                </div> : null}
                            <Row></Row>
                            <Row>
                                {post2?.map((post, index) => (
                                    <Col md={4} lg={3} key={index} className="mb-4">
                                        <Card className="bg-transparent border-0 h-100">
                                            <button className="fancyBox rounded-5 overflow-hidden h-100 d-block border-0 p-0" data-src={`#${post.url_slug}-content`}
                                            >
                                                <SourceFlowImage
                                                    src={post?.image ? post.image : "/site-assets/placeholders/img-placeholder.jpg"}
                                                    size="x1000"
                                                    alt={post?.title}
                                                    className="card-img rounded-0 h-100"
                                                />
                                            </button>
                                            <div className="p-3">
                                                <p className="post-title fs-5 mb-0"><strong>{post?.title}</strong></p>
                                                <p className="post-position">{post?.position}</p>
                                                <Nav className="d-flex contacts mt-2">
                                                    {post.email ?
                                                        <NavItem className="position-relative">
                                                            <Link href={`mailto:${post?.email}`}>
                                                                <a className="text-decoration-none" title="Mail">
                                                                    <Mail />
                                                                </a>
                                                            </Link>
                                                        </NavItem> : null}
                                                    {post.telephone ?
                                                        <NavItem className="position-relative">
                                                            <Link href={`tel:${post?.telephone}`}>
                                                                <a className="text-decoration-none" title="Telephone">
                                                                    <Phone />
                                                                </a>
                                                            </Link>
                                                        </NavItem> : null}
                                                    {post.linkedin ?
                                                        <NavItem className="position-relative">
                                                            <Link href={`${post?.linkedin}`}>
                                                                <a className="text-decoration-none" target="_blank" rel="noopener noreferrer" title="LinkedIn">
                                                                    <LinkedIn />
                                                                </a>
                                                            </Link>
                                                        </NavItem> : null}
                                                </Nav>
                                            </div>
                                            {post?.content ?
                                                <div id={`${post.url_slug}-content`} className="consultant-pop-content p-0 rounded-4">
                                                    <Row className="a">
                                                        <Col md={4} className="">
                                                            <SourceFlowImage
                                                                src={post?.image ? post.image : "/site-assets/placeholders/img-placeholder.jpg"}
                                                                size="x1000"
                                                                alt={post?.title}
                                                                className="card-img rounded-4 h-100"
                                                            />
                                                        </Col>
                                                        <Col md={8} className="p-4 p-md-5">
                                                            <p className="post-title fs-5 mb-0"><strong>{post?.title}</strong></p>
                                                            <p className="post-position">{post?.position}</p>
                                                            <Nav className="d-flex contacts mt-2">
                                                                {post.email ?
                                                                    <NavItem className="position-relative">
                                                                        <Link href={`mailto:${post?.email}`}>
                                                                            <a className="text-decoration-none" title="Mail">
                                                                                <Mail />
                                                                            </a>
                                                                        </Link>
                                                                    </NavItem> : null}
                                                                {post.telephone ?
                                                                    <NavItem className="position-relative">
                                                                        <Link href={`tel:${post?.telephone}`}>
                                                                            <a className="text-decoration-none" title="Telephone">
                                                                                <Phone />
                                                                            </a>
                                                                        </Link>
                                                                    </NavItem> : null}
                                                                {post.linkedin ?
                                                                    <NavItem className="position-relative">
                                                                        <Link href={`${post?.linkedin}`}>
                                                                            <a className="text-decoration-none" target="_blank" rel="noopener noreferrer" title="LinkedIn">
                                                                                <LinkedIn />
                                                                            </a>
                                                                        </Link>
                                                                    </NavItem> : null}
                                                            </Nav>
                                                            {post?.content ?
                                                                <div className="post-content mt-5" dangerouslySetInnerHTML={{ __html: post?.content }} />
                                                                : ""}
                                                        </Col>
                                                    </Row>
                                                </div> : null}
                                        </Card>
                                    </Col>
                                ))}
                            </Row>
                        </>
                    )}
                </Container >
            </section >
        )
    )
}